import SunnyIcon from '../assets/icons/weather/sunny.png';
import CloudyIcon from '../assets/icons/weather/cloudy.png';
import FogIcon from '../assets/icons/weather/fog.png';
import LightningIcon from '../assets/icons/weather/lightning.png';
import BlizzardIcon from '../assets/icons/weather/blizzard.png';
import SnowIcon from '../assets/icons/weather/snow.png';
import HeavySnowIcon from '../assets/icons/weather/heavy_snow.png';
import LightRainIcon from '../assets/icons/weather/light_rain.png';
import RainIcon from '../assets/icons/weather/rain.png';
import HeavyRainIcon from '../assets/icons/weather/rain.png';
import { WeatherCode, WeatherForecast, WeatherForecastApi } from '../types/weather';

export const transformWeatherForecasts = (data: WeatherForecastApi[] | null | undefined): WeatherForecast[] => {
  if (!data) return [];

  return data.map<WeatherForecast>((item) => {
    const {
      daily_summary: { air_temperature, precipitation, wind_direction, wind_speed, icon },
      local_date,
    } = item;

    let appIcon: string;
    let code: WeatherCode | null = null;
    switch (icon) {
      case 'sunny':
        appIcon = SunnyIcon;
        code = 'sunny';
        break;
      case 'cloudy':
        appIcon = CloudyIcon;
        code = 'cloudy';
        break;
      case 'fog':
        appIcon = FogIcon;
        code = 'fog';
        break;
      case 'lightning':
        appIcon = LightningIcon;
        code = 'lightning';
        break;
      case 'blizzard':
        appIcon = BlizzardIcon;
        code = 'blizzard';
        break;
      case 'snow':
        appIcon = SnowIcon;
        code = 'snow';
        break;
      case 'heavy_snow':
        appIcon = HeavySnowIcon;
        code = 'snow';
        break;
      case 'light_rain':
        appIcon = LightRainIcon;
        code = 'rain';
        break;
      case 'rain':
        appIcon = RainIcon;
        code = 'rain';
        break;
      case 'heavy_rain':
        appIcon = HeavyRainIcon;
        code = 'rain';
        break;
      default:
        appIcon = '';
    }

    return {
      temperature: air_temperature,
      precipitation: precipitation.avg ?? 0,
      windDirection: wind_direction.avg || null,
      windSpeed: wind_speed.avg || null,
      date: local_date,
      iconSrc: appIcon,
      code,
    };
  });
};
